import script from "./TopCountryItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TopCountryItem.vue?vue&type=script&setup=true&lang=js"

import "./TopCountryItem.vue?vue&type=style&index=0&id=1c53e71f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c53e71f"]])

export default __exports__